import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    verifyWarehouseFile (file) {
        return httpService.post(ApiEndpoints.get('fcp_verify_warehouse'), file);
    },
    executeWarehouseFile (file) {
        return httpService.post(ApiEndpoints.get('fcp_execute_warehouse'), file);
    },
    verifyFamiliesFile (file) {
        return httpService.post(ApiEndpoints.get('fcp_verify_families'), file);
    },
    executeFamiliesFile (file) {
        return httpService.post(ApiEndpoints.get('fcp_execute_families'), file);
    },
    verifyBubblesFile (file) {
        return httpService.post(ApiEndpoints.get('fcp_verify_bubbles'), file);
    },
    executeBubblesFile (file) {
        return httpService.post(ApiEndpoints.get('fcp_execute_bubbles'), file);
    },
    getCounters () {
        return httpService.get(ApiEndpoints.get('fcp_counters'));
    },
    getCurrentBubbles () {
        return httpService.get(ApiEndpoints.get('fcp_current_bubbles'), {
            responseType: 'blob'
        });
    },
    getCurrentBubbleWarehouses () {
        return httpService.get(ApiEndpoints.get('fcp_current_bubble_warehouses'), {
            responseType: 'blob'
        });
    },
    getCurrentWarehouseFamilies () {
        return httpService.get(ApiEndpoints.get('fcp_current_warehouse_families'), {
            responseType: 'blob'
        });
    }
};
